import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { PosService } from "src/app/core/services/pos.service";
import { CheckSeatDto } from "src/app/shared/models/check-dto";

@Component({
	selector: "app-pos-on-screen-check-header",
	templateUrl: "./pos-on-screen-check-header.component.html",
	styleUrls: ["./../../../pos.scss"],
})
export class PosOnScreenCheckHeaderComponent implements OnInit {
	@Input() seatSelected: CheckSeatDto;
	@Output() seatSelectedChange = new EventEmitter<CheckSeatDto>();

	@Output() checkSelectorChange = new EventEmitter<any>();

	seatPickerOptions: {
		label: string;
		value: number;
	}[] = [];

	selectedSeatKey: number;

	constructor(public posService: PosService) {}

	ngOnInit(): void {
		this.posService.orderService.activeOrder.subscribe((data) => {
			console.log(`this changed`);
			if (data.seats?.length > 0) {
				this.seatPickerOptions = data.seats.map((seat, idx) => {
					return {
						label: `Seat ${seat.seatKey}`,
						value: seat.seatKey,
					};
				});
				if (!this.seatSelected) {
					this.posService.orderService.activeSeat.next(this.posService.orderService.activeOrder.value.seats[0]);
				}
			}
		});
	}

	onSeatSelect(seatKey: number) {
		console.log(`seat change to ${this.selectedSeatKey}`);
		this.posService.orderService.activeSeat.next(this.posService.orderService.activeOrder.value.seats.find((seat) => seat.seatKey === seatKey));
	}
}
